import { render, staticRenderFns } from "./orderAllocationList.vue?vue&type=template&id=f3220512&scoped=true&"
import script from "./orderAllocationList.vue?vue&type=script&lang=js&"
export * from "./orderAllocationList.vue?vue&type=script&lang=js&"
import style0 from "./orderAllocationList.vue?vue&type=style&index=0&id=f3220512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3220512",
  null
  
)

export default component.exports